import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {TaskModel} from "../../../tasks/models/task.model";

export class planningRouteTasksTableCtrl implements IController {
  tasks: any;
  forcedStartTaskIds: any;
  forcedEndTaskIds: any;
  routeAnalysis: any;
  highlightedTaskId: any;
  selectedIds: any;
  queryString: any;
  onHighlightedTaskSelect: Function;
  onToggleTask: Function;
  onToggleSelectAll: Function;
  onRemove: Function;
  onEditBoundEquipment: Function;
  onToggleForcedStartTasks: Function;
  onToggleForcedEndTasks: Function;

  public selectedKeys: any = {};
  public dropableKeys: any = {};
  public hasPermissionToEdit: any = undefined;
  public treeOptions: any = {};
  public forcedStartTaskKeys: any;
  public forcedEndTaskKeys: any;
  public displayAsItems: any;


  constructor(private IAMPermissions, private tasksService: TasksService, private $mdMedia) {
  }

  $onInit() {
    this.hasPermissionToEdit = this.IAMPermissions.hasPermission('planning.routes.update');
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (selectedId) => {
        this.selectedKeys[selectedId] = true;
      })
    }
    if (changes.forcedStartTaskIds) {
      this.forcedStartTaskKeys = [];

      _.forEach(this.forcedStartTaskIds, (forcedId) => {
        this.forcedStartTaskKeys[forcedId] = true;
      })

      // adding relevant bundles
      const forcedStartBundleIds = _.chain(this.tasks)
        .filter((task: TaskModel) => {
          return task.taskType === 'BundledStopover' &&
            _.difference(task.taskIdList, this.forcedStartTaskIds).length < task.taskIdList.length;
        })
        .map('id')
        .value();

      _.forEach(forcedStartBundleIds, (bundleId) => {
        this.forcedStartTaskKeys[bundleId] = true;
      })

    }
    if (changes.forcedEndTaskIds) {
      this.forcedEndTaskKeys = [];

      _.forEach(this.forcedEndTaskIds, (forcedId) => {
        this.forcedEndTaskKeys[forcedId] = true;
      })

      // adding relevant bundles
      const forcedEndBundleIds = _.chain(this.tasks)
        .filter((task: TaskModel) => {
          return task.taskType === 'BundledStopover' &&
            _.difference(task.taskIdList, this.forcedEndTaskIds).length < task.taskIdList.length;
        })
        .map('id')
        .value();

      _.forEach(forcedEndBundleIds, (bundleId) => {
        this.forcedEndTaskKeys[bundleId] = true;
      })

    }
  };

  $doCheck() {
    this.displayAsItems = !this.$mdMedia('gt-sm');
  };

}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRouteTasksTable', {
    bindings: {
      tasks: '<',
      forcedStartTaskIds: '<',
      forcedEndTaskIds: '<',
      routeAnalysis: '<',
      highlightedTaskId: '<',
      selectedIds: '<',
      queryString: '<',
      onHighlightedTaskSelect: '&',
      onToggleTask: '&',
      onToggleSelectAll: '&',
      onRemove: '&',
      onEditBoundEquipment: '&',
      onToggleForcedStartTasks: '&',
      onToggleForcedEndTasks: '&'
    },
    template: require('./planning-route-tasks-table.html').default,
    controller: planningRouteTasksTableCtrl
  });
